import { useFunction } from "@project-rouge/rg-three";
import { useMemo, useState } from "react";
function useMemoState(initialState, dependencies = [initialState]) {
  const memoDeps = useMemo(() => dependencies, dependencies);
  const [_state, _setState] = useState({ value: initialState, memoDeps });
  const setState = useFunction((value) => _setState({ value, memoDeps }));
  const currState = memoDeps === _state.memoDeps ? _state.value : initialState;
  return [currState, setState];
}
export {
  useMemoState
};
//# sourceMappingURL=index38.js.map
